export const CIRCLE_TYPE = {
    'success': 'green-border',
    'info': 'blue-border',
    'error': 'red-border'
};
